import styled from "styled-components";
import {dialogHighlightedTextMixin, dialogTextMixin} from "../../../modal-dialog/boxes/text/dialog-text.box";

export const GamblingSessionInfoWrapperBox = styled.div`
    margin-bottom: 1.5rem;
`;

export const GamblingSessionInfoTextBox = styled.div`
    ${dialogTextMixin}
`;

export const GamblingSessionInfoValueBox = styled.div`
    ${dialogHighlightedTextMixin}
`;
